import * as React from 'react';
import underDev from '../assets/Under-construction.gif';

export const UnderDevelopment = (): JSX.Element => {
  return (
    <div className="">
      <h6 className="2xl:text-3xl text-2xl mb-3 text-center font-bold">
        This page is currently under development
      </h6>
      <img src={underDev} className="mx-auto" />
    </div>
  );
};
